import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from 'components/Link';

import styles from './WaffleHeadlineStyles.module.scss';

class WaffleHeadline extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    headline: PropTypes.string.isRequired,
    nativeAd: PropTypes.bool,
    sponsorName: PropTypes.string,
    vertical: PropTypes.string,
    isTwoUpMobile: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    url: '',
    nativeAd: false,
    sponsorName: '',
    vertical: '',
    isTwoUpMobile: false,
    className: '',
  };

  render() {
    const {
      url,
      headline,
      nativeAd,
      sponsorName,
      vertical,
      isTwoUpMobile,
      className,
    } = this.props;

    const isToday = vertical === 'today';
    const isSweetOrSpicyText = isToday || vertical === 'think' || vertical === 'knowyourvalue';

    const headlineIsLinkable = !!(url);
    const headlineIsNotLinkable = !headlineIsLinkable;

    const headlineClasses = classNames(
      className,
      'font-hed mv0',
      {
        'lh-none fw7': !isSweetOrSpicyText,
        'lh-title fw3': isSweetOrSpicyText,
        'color-secondary ': isToday && !nativeAd,
        'gray-100': !isToday && !nativeAd,
        white: nativeAd,
        'f7 f6-m f7-xl': isSweetOrSpicyText && !isTwoUpMobile,
        'f4 f6-m f7-xl': isSweetOrSpicyText && isTwoUpMobile,
        f7: !isSweetOrSpicyText && !isTwoUpMobile,
        'f5 f7-m': !isSweetOrSpicyText && isTwoUpMobile,
        [styles.disabled]: headlineIsNotLinkable,
      },
    );
    const sponsorNameClasses = classNames(
      'mt3 f3 ls-tight gray-60 lh-none founders-mono',
    );

    const Headline = (
      <React.Fragment>
        <h2 className={classNames(headlineClasses, styles.headlineHover)} data-test="waffle-headline">
          {headline}
        </h2>
        {(nativeAd && sponsorName)
          && (
          <p className={sponsorNameClasses} data-test="waffle-headline__sponsor">
            {sponsorName}
          </p>
          )}
      </React.Fragment>
    );
    if (url) {
      return (
        <Link to={url} className="db">
          {Headline}
        </Link>
      );
    }
    return Headline;
  }
}

export default WaffleHeadline;
